/**
 * Bootstrap 5.3 Theme Switcher
 * Detects system preference and allows manual override.
 * Only applies data-bs-theme="dark" when dark mode is active;
 * default (light) styling uses no data-bs-theme attribute.
 */
(function() {
    const DARK = 'dark';
    const THEME_PREFERENCE_KEY = 'theme-preference';

    /**
     * Determine whether dark mode should be active.
     *
     * @returns {boolean} True when dark mode is preferred.
     */
    function isDarkPreferred() {
        const stored = localStorage.getItem(THEME_PREFERENCE_KEY);

        if (stored) {
            return stored === DARK;
        }

        return window.matchMedia('(prefers-color-scheme: dark)').matches;
    }

    /**
     * Apply or remove the dark theme attribute on the document element
     * and synchronise the toggle control.
     *
     * @param {boolean} isDark - Whether dark mode should be active.
     */
    function applyTheme(isDark) {
        if (isDark) {
            document.documentElement.setAttribute('data-bs-theme', DARK);
        } else {
            document.documentElement.removeAttribute('data-bs-theme');
        }

        const themeToggle = document.getElementById('theme-toggle');

        if (themeToggle) {
            themeToggle.checked = isDark;
            themeToggle.setAttribute(
                'aria-label',
                isDark ? 'Switch to light mode' : 'Switch to dark mode'
            );
        }

        const themeToggleLabelText = document.getElementById('theme-toggle-accessibility-label');

        if (themeToggleLabelText) {
            themeToggleLabelText.textContent = isDark ? 'Switch to light mode' : 'Switch to dark mode';
        }

        const themeToggleText = document.getElementById('theme-toggle-text');

        if (themeToggleText) {
            themeToggleText.textContent = isDark ? 'Switch to light mode' : 'Switch to dark mode';
        }
    }

    /**
     * Toggle between dark mode and default styling, persisting the
     * choice to localStorage.
     */
    function toggleTheme() {
        const nowDark = !isDarkPreferred();

        localStorage.setItem(THEME_PREFERENCE_KEY, nowDark ? DARK : 'default');
        applyTheme(nowDark);
    }

    // Apply theme immediately to avoid flash of incorrect styles.
    applyTheme(isDarkPreferred());

    // React to system preference changes when the user has no stored preference.
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
        if (!localStorage.getItem(THEME_PREFERENCE_KEY)) {
            applyTheme(e.matches);
        }
    });

    // Expose toggle globally.
    window.themeToggle = toggleTheme;

    // Wire up the toggle control once the DOM is ready.
    document.addEventListener('DOMContentLoaded', () => {
        // Re-apply theme now that DOM elements are available.
        applyTheme(isDarkPreferred());

        const themeToggle = document.getElementById('theme-toggle');

        if (themeToggle) {
            themeToggle.addEventListener('change', toggleTheme);
        }
    });
})();